module.exports = __webpack_public_path__ + "img/share.67d84c54.svg";